<template>
  <div class="maxw">
    <h2>Facturarxx</h2>
    <b-row>
      <b-col>
        <b-form-group label="Grupo:" label-for="input-nif">
          <b-form-select
            v-model="series"
            :options="grups"
            value-field="identifier"
            text-field="nombre"
          >
            <template #first>
              <b-form-select-option :value="null"
                >-- Seleccione una Serie --</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  data () {
    return {
      loading: true,
      clients: null,
      series: null,
      form: {
        serie: null,
        dataFactura: null,
        client: null
      }
    }
  },
  created () {
    (async () => {
      await DataAccess.getDataMuliplex2('/api/clients', '/api/series')
        .then((responses) => {
          // const responseOne = responses[0]
          // const responseTwo = responses[1]
          this.clients = responses[0].data
          this.series = responses[1].data
          this.loading = false
        })
        .catch((error) => {
          console.log('ERROR: ', error)
        })
    })()
  }
}
</script>
